var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3338 3.65614C12.4608 3.65614 11.6236 4.03182 11.0064 4.70052L4.3397 11.9227C3.72243 12.5915 3.37565 13.4984 3.37565 14.4441C3.37565 15.3898 3.72243 16.2968 4.3397 16.9655C4.95696 17.6342 5.79416 18.0099 6.66711 18.0099C7.54006 18.0099 8.37725 17.6342 8.99452 16.9655L15.6612 9.74325C16.2785 9.07454 16.6252 8.16758 16.6252 7.22189C16.6252 6.27619 16.2785 5.36923 15.6612 4.70052C15.0439 4.03182 14.2067 3.65614 13.3338 3.65614ZM3.16119 10.646C2.23136 11.6533 1.70898 13.0196 1.70898 14.4441C1.70898 15.8687 2.23136 17.2349 3.16119 18.2422C4.09101 19.2495 5.35213 19.8154 6.66711 19.8154C7.98208 19.8154 9.2432 19.2495 10.173 18.2422L16.8397 11.02C17.7695 10.0127 18.2919 8.64644 18.2919 7.22189C18.2919 5.79733 17.7695 4.43112 16.8397 3.4238C15.9099 2.41649 14.6488 1.85059 13.3338 1.85059C12.0188 1.85059 10.7577 2.41649 9.82785 3.4238L3.16119 10.646Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49408 7.03493C6.81951 6.68237 7.34715 6.68237 7.67259 7.03493L13.5059 13.3544C13.8314 13.7069 13.8314 14.2785 13.5059 14.6311C13.1805 14.9836 12.6528 14.9836 12.3274 14.6311L6.49408 8.31165C6.16864 7.95909 6.16864 7.38748 6.49408 7.03493Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPill);
export default __webpack_public_path__ + "static/media/pill.25909d438b74382e75ddc2ec53cc7836.svg";
export { ForwardRef as ReactComponent };